"use client";

import { ArrowRight, MapPin } from "lucide-react";
import { Link } from "@/components/common/Link";
import { AspectRatio } from "@/components/ui/aspect-ratio";
import { Button } from "@/components/ui/button";
import { Separator } from "@/components/ui/separator";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function ReachOurCaboOffice() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  const hours = [{
    label: "MON–FRI",
    time: "9:00 AM — 6:00 PM"
  }, {
    label: "SATURDAY",
    time: "10:00 AM — 2:00 PM"
  }, {
    label: "SUNDAY",
    time: "Closed"
  }, {
    label: "CONSULTATIONS",
    time: "By Appointment"
  }];
  return;
}